import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { switchMap, filter, take, catchError } from 'rxjs/operators';
import { OAuthService } from '@app/auth/oauth.service';
import { AuthStatus, AuthState } from '@app/auth/auth.state';
import { env } from '@envs/env';
import * as i0 from "@angular/core";
import * as i1 from "../auth/oauth.service";
import * as i2 from "../auth/auth.state";
export class FlumeApiInterceptor {
    constructor(oauthService, authState) {
        this.oauthService = oauthService;
        this.authState = authState;
        this.absUrlTest = new RegExp('^(?:[a-z]+:)?//', 'i');
        this.exceptions = ['/oauth/token'];
    }
    intercept(req, next) {
        req = this.addBaseUrl(req);
        // Add access token to the headers
        req = this.addAuthenticationToken(req);
        req = req.clone({
            headers: req.headers
                .set('Cache-Control', 'no-cache')
                .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                .set('If-Modified-Since', '0'),
        });
        return next.handle(req).pipe(catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                return this.oauthService.authEvents$.pipe(filter((state) => state === AuthStatus.AUTH_VALID), take(1), switchMap(() => {
                    req = this.addBaseUrl(req);
                    return next.handle(this.addAuthenticationToken(req));
                }));
            }
            if (error instanceof HttpErrorResponse && error.status === 403) {
                this.oauthService.clearTokens();
            }
            return throwError(error);
        }));
    }
    addBaseUrl(req) {
        if (!this.absUrlTest.test(req.url)) {
            req = req.clone({ url: `${env.apiUrl}${req.url}` });
        }
        return req;
    }
    addAuthenticationToken(request) {
        const token = this.oauthService.getAccessToken();
        if (!token) {
            return request;
        }
        if (!request.url.includes(env.apiUrl) || request.url.includes('/oauth/token')) {
            return request;
        }
        return request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token),
        });
    }
}
FlumeApiInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FlumeApiInterceptor_Factory() { return new FlumeApiInterceptor(i0.ɵɵinject(i1.OAuthService), i0.ɵɵinject(i2.AuthState)); }, token: FlumeApiInterceptor, providedIn: "root" });
